module.exports = __webpack_public_path__ + "NexaBlack.6d2569dba4b28a59b27f.woff";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/NexaBlack.woff
// module id = ../../../../../src/assets/fonts/NexaBlack.woff
// module chunks = 2